import { useTranslation } from "react-i18next";
import AgyleAccordion from "../../../../components/ui/accordion/agyleAccordion";
import usePatientAppointments from "../scheduler/scheduledAppointments/usePatientAppointments";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import AgyleLoadingSpinner from "../../../../components/other/agyleLoadingSpinner";
import { Typography } from "@mui/material";
import { SLOT_STATUSES } from "../../../appointments/utils/constants/appointmentSessionConstants";
import React from "react";
import { find, isEqual, orderBy } from "lodash";

const useStyles = makeStyles((theme) => ({
  counter: {
    marginLeft: "auto",
    height: 24,
  },
  spinner: {
    display: "flex",
    paddingTop: 3,
  },
}));

const AppointmentsAccordion = ({ expanded, onChange, patient }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [appointmentList, appointmentsLoading] = usePatientAppointments({
    hospitalNumber: patient?.patient?.__id,
    startDate: moment().format("DD-MM-YYYY"),
  });

  const getStatus = (status) => {
    return find(SLOT_STATUSES, (s) => s.value === status);
  };

  const getAppointmentSlots = () => {
    if (!appointmentList || appointmentList.length === 0) {
        return <Typography variant="h6">{t('Patient has no upcoming scheduled appointments')}</Typography>;
    }

    const sortedAppointments = orderBy(appointmentList, ["startDate"], ["asc"]);

    return sortedAppointments.map((appointment, index) => {
      const status = getStatus(appointment?.status);

      return (
        <div key={appointment?.__id}>
          <Typography variant="body1">
            <strong>{t("Date")}:</strong>{" "}
            {moment(appointment?.startDate).format("DD/MM/YYYY")}
          </Typography>

          <Typography variant="body1">
            <strong>{t("Time")}:</strong>{" "}
            {moment(appointment?.startDate).format("HH:mm")}
          </Typography>

          <Typography variant="body1">
            <strong>{t("Reason")}:</strong> {appointment?.description || "N/A"}
          </Typography>

          <Typography variant="body1">
            <strong>{t("Status")}:</strong> {status.name || "-"}
          </Typography>

          {index < appointmentList.length - 1 && (
            <hr style={{ margin: "10px 0" }} />
          )}
        </div>
      );
    });
  };

  return (
    <AgyleAccordion
      expanded={expanded === "appointments"}
      onChange={onChange("appointments")}
      label={t("Appointments")}
      secondLabel={
        appointmentsLoading ? (
          <AgyleLoadingSpinner
            disableText
            spinnerSize={16}
            className={classes.spinner}
          />
        ) : (
          t(`Booked: ${appointmentList?.length ?? 0}`)
        )
      }
      secondHeadingStyle={classes.counter}
    >
      {getAppointmentSlots()}
    </AgyleAccordion>
  );
};

function areEqual(prevProps, nextProps) {
  let equal = isEqual(prevProps.expanded, nextProps.expanded);
  return equal && isEqual(prevProps.patient, nextProps.patient);
}

export default React.memo(AppointmentsAccordion, areEqual);
